import { FETCH_HOST_PRICING, RECEIVE_HOST_PRICING, RECEIVE_HOST_PRICING_ERROR } from '../actions/HostPricing';
export const makeHostPricingState = _ref => {
  let {
    pending,
    error,
    result
  } = _ref;
  return {
    hostPricing: {
      pending,
      error,
      result
    }
  };
};
export default function HostPricingReducer() {
  let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : makeHostPricingState({
    pending: true,
    error: null,
    result: null
  });
  let action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case FETCH_HOST_PRICING:
      return makeHostPricingState({
        pending: true,
        error: null,
        result: null
      });
    case RECEIVE_HOST_PRICING:
      return makeHostPricingState({
        pending: false,
        error: null,
        result: action.hostPricing
      });
    case RECEIVE_HOST_PRICING_ERROR:
      return makeHostPricingState({
        pending: false,
        error: action.error,
        result: null
      });
    default:
      // Flow compile-time validation that we've handled every action
      // prettier-ignore
      action;
      return state;
  }
}